import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { LimitFlowProposalService } from '../../../service/limit-flow-proposal/limit-flow-proposal.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import { ActivatedRoute, Router } from '@angular/router';

export interface RequestPendingApprovalModel {
	accountClientID: string,
	proposalID: string,
	proposalCTC: string,
	userProfile: string
}

@Component({
	selector: 'app-request-pending-approval',
	templateUrl: './request-pending-approval.component.html',
	styleUrls: ['./request-pending-approval.component.scss'],
	providers: [
		LimitFlowProposalService
	]
})
export class RequestPendingApprovalComponent extends DialogComponent<RequestPendingApprovalModel, boolean> implements RequestPendingApprovalModel {

	accountClientID: string;
	proposalID: string;
	proposalCTC: string;
	userProfile: string;

	public ctcs: any[] = [];

	public ctc: string = "";
	public mensagem;

	constructor(dialogService: DialogService, private router: Router, private flashMessagesService: FlashMessagesService, private limitFlowProposalService: LimitFlowProposalService) {
		super(dialogService);
	}

	ngOnInit() {
		this.getCtcByAccountClient(this.accountClientID);
	}

	getCtcByAccountClient(id) {
		this.limitFlowProposalService.getCtcByAccountClient(id).subscribe(result => {
			if (result.Success) {
				this.ctcs = result.Result;

				this.ctc = (!this.proposalCTC && this.ctcs.length === 1 ? this.ctcs[0].CodigoSap : this.proposalCTC);
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		})
	}

	requestPending() {
		var data = {};

		if (this.mensagem.length <= 5000) {
			data = {
				ID: this.proposalID,
				CodigoSap: this.ctc,
				Mensagem: this.mensagem
			}

			this.limitFlowProposalService.requestCtcPendingAproval(data).subscribe(result => {
				if (result.Success) {
					this.flashMessagesService.show("Solicitação encaminhada ao CTC", { cssClass: 'alert-success', timeout: 6000 });
					this.confirm();
				} else {
					this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
				}
			}, error => {
				console.log(error);
			})
		} else {
			this.flashMessagesService.show("Esta mensagem excedeu o máximo de caracteres permitido. (max. 5000 caracteres)", { cssClass: 'alert-danger', timeout: 6000 });
		}
	}

	confirm() {
		this.result = true;
		this.close();
	}
}



// WEBPACK FOOTER //
// ./src/app/limit-flow-proposal/component/actions/request-pending-approval/request-pending-approval.component.ts